import {DigitalPageItem} from '../../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Sample,
  Title: '¡Hola!',
  ProductCode: 'spas43',
  Description:
   '<p>Try some of the online revision included with our Spanish revision books. Get full access to all the features when you <a href="[[external_domain]]/info/new-gcse-mfl-books" class="link-button" style="color: #FF9335;">buy your book</a> and unlock CGP RevisionHub with the unique code printed inside!</p>',
  Credits:
   '<p><em>Contributors: Matthew Parkinson, Jacqui Richards, Clare Swayne </em></p>\n'+
    '\n'+
    '<p><em>Proofreaders: Encarna Aparicio-Dominguez, Lara Falomir Dominguez, Gail Partington, Suzanne Rose </em></p>\n'+
    '\n'+
    '<p><em>AQA material is reproduced by permission of AQA. The worked solutions to questions and commentaries on questions and possible answers in this product have neither been provided by nor approved by AQA.</em></p>\n'+
    '\n'+
    '<p><em>Audio produced by Voice Talent Online.</em></p>\n'+
    '\n'+
    '<p><em>Text, design, layout and original illustrations &copy; Coordination Group Publications Ltd. (CGP) 2024. All rights reserved.</em></p>\n',
  FreeSampleContent:
    '<strong>This is a free sample of the CGP RevisionHub for GCSE Spanish. <a href="[[external_domain]]/info/new-gcse-mfl-books" class="link-button" style="color: #FF9335;">Order</a> your book now for full access to online Spanish revision.</strong>',
};
